import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    click() { /* do nothing */ },
    set(_, action) {
      return action.payload;
    },
    updateFavorite(state, action) {
      const { categoryId = 0, tableId, add } = action.payload;

      const categoryIndex = state.findIndex((cat) => cat.id === categoryId);

      if (categoryIndex === -1) return state; // Return the current state if category isn't found

      const category = state[categoryIndex];
      const tables = category.tables.map(Number);

      const updatedTables = add
        ? tables.includes(tableId)
          ? tables
          : [ ...tables, tableId ]
        : tables.filter((id) => id !== tableId);

      return [
        ...state.slice(0, categoryIndex),
        { ...category, tables: updatedTables },
        ...state.slice(categoryIndex + 1),
      ];
    },
  },
});

export const categories = categoriesSlice.actions;
export default categoriesSlice.reducer;
